var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((this.vesselHatch?.vesselBays),function(vesselBay,index){return _c('v-col',{key:`all-monitoring-hatch-${index}`,attrs:{"cols":"12"}},[_c('vessel-monitoring-bay',{attrs:{"minDeckTiersNo":_vm.minDeckTiersNo,"minHoldTiersNo":_vm.minHoldTiersNo,"vesselHatch":_vm.vesselHatch,"vesselBay":vesselBay}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }